module.exports = __webpack_public_path__ + "img/17.1fd994d1.jpg";